export default "__VITE_ASSET__BZvjRRwp__"